import { createRoot } from 'react-dom/client';
import { App } from './App';
import { installTranslationHeadings } from '../../../packages/core/src/translationHeadings';

/* the quiz hint (classic engine) shows translation section headings as title lines */
installTranslationHeadings();

createRoot(document.getElementById('react-root')!).render(<App />);
